import * as React from 'react';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useState } from "react";
import axios from '../axios';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchFilter from './SearchFilter';
import SearchResultsTable from './SearchResultsTable';
import SearchResultsTableMobile from './SearchResultsTableMobile';
import DrawerDetails from './DrawerDetails';
// global states
import { useStateValue } from "../StateProvider";
import { actionTypes } from '../reducer';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const columns = [
    { id: 'rating', label: 'Rating' },
    { id: 'company_name', label: 'Company Name' },
    { id: 'mc', label: 'MC #' },
    { id: 'dot', label: 'DOT #' },
    { id: 'city', label: 'City' },
    { id: 'state', label: 'State' },
];

export default function Searchtable() {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [dataFiltered, setDataFiltered] = React.useState([]);
    const [dataValue, setDataValue] = React.useState({});
    const [open, setOpen] = React.useState(false);

    const [state, setState] = React.useState(false);
    const [drawerValue, setDrawerValue] = React.useState({});

    const [companyName, setCompanyName] = React.useState("");
    const [mc, setMc] = React.useState("");
    const [dot, setDot] = React.useState("");

    const [{ }, dispatch] = useStateValue();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleSearch = (companyName, mc, dot) => {
        setPage(0)
        setRowsPerPage(10)
        //setDataFiltered(sampleData)
        dispatch({
            type: actionTypes.SET_SHOW_PROCESSING,
            showProcessing: {
                show: true,
                title: "Searching Applicant...",
            },
        });
        axios
            .post(`/api/search_company/`,
                {
                    "company_name": companyName,
                    "mc": mc,
                    "dot": dot
                })
            .then((response) => {
                // console.log("data:", JSON.stringify(response.data))
                setDataFiltered(response.data)
                dispatch({
                    type: actionTypes.SET_SHOW_PROCESSING,
                    showProcessing: {
                        show: false,
                        title: "Searching Applicant...",
                    },
                });
                if (response.data.length <= 0) {
                    handleClickOpen();
                }
            }).catch((error) => {
                handleClickOpen();
                dispatch({
                    type: actionTypes.SET_SHOW_PROCESSING,
                    showProcessing: {
                        show: false,
                        title: "Searching Applicant...",
                    },
                });
                setDataFiltered([])

            });
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const toggleDrawer = (open, value) => {
        setDrawerValue(value);
        setState(open);
    };

    const handleCloseDrawer = () => {
        setState(false);
    }

    return (
        <>
            <div sx={{ width: '100%', overflow: 'scroll' }}>
                {/* SEARCH FILTER COMPONENT */}
                <SearchFilter handleSearch={handleSearch} />
                {dataFiltered?.length > 0 &&
                    <Grid container width={'100vw'} padding={'1rem'}>
                        <Grid item xs={6}>
                            <Typography color={'#58A618'}>Search Results: {dataFiltered.length}</Typography>
                        </Grid>
                        <Grid item xs={6} textAlign={'right'}>
                        </Grid>
                    </Grid>
                }
                <Grid sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }}>
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                {/* SEARCH RESULT TABLE COMPONENT */}
                                <SearchResultsTable toggleDrawer={toggleDrawer} dataFiltered={dataFiltered} rowsPerPageParent={rowsPerPage} pageParent={page} />
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                <Grid sx={{ display: { xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' } }}>
                    <SearchResultsTableMobile toggleDrawer={toggleDrawer} dataFiltered={dataFiltered} rowsPerPageParent={rowsPerPage} pageParent={page} />
                </Grid>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={dataFiltered.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    style={{ paddingBottom: '5rem' }}
                />
            </div>
            <div>
                <React.Fragment key={'right'}>
                    <Drawer
                        anchor='right'
                        open={state}
                        onClose={handleCloseDrawer}
                        PaperProps={{
                            sx: { width: "25%", minWidth: "220px" },
                        }}
                    >
                        <Box
                            role="presentation"
                        // onClick={handleCloseDrawer}
                        // onKeyDown={handleCloseDrawer}
                        >

                            <DrawerDetails drawerValue={drawerValue} />
                        </Box>
                    </Drawer>
                </React.Fragment>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"No Results Found"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Email us at creditinquiry@tabbank.com for more information.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}